import { render } from "./Vertical.vue?vue&type=template&id=0cca1136&ts=true"
import script from "./Vertical.vue?vue&type=script&lang=ts"
export * from "./Vertical.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__